import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { uniqueId } from 'lodash-es';
import { useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { Collapse } from 'react-collapse';
import { FormField } from './form-field';
import dropDownIcon from '../../images/dropdown-button.svg';
export function RangeDropdown(props) {
    const collpaseId = useMemo(() => uniqueId('range-dropdown-collapse'), []);
    const { value, placeholder, onChange } = props;
    const [minimum, maximum] = useMemo(() => value ? value.split(',') : ['', ''], [value]);
    const updateMinimum = useCallback((newMinimum) => {
        onChange([newMinimum, maximum].join(','));
    }, [onChange, maximum]);
    const updateMaximum = useCallback((newMaximum) => {
        onChange(([minimum, newMaximum]).join(','));
    }, [onChange, minimum]);
    /* Handle open/close logic */
    const [isOpen, setIsOpen] = useState(false);
    const handleClick = useCallback(() => {
        setIsOpen(isOpen => !isOpen);
    }, [setIsOpen]);
    const componentRef = useRef(null);
    const collapseHandler = useCallback((event) => {
        // Collapse the dropdown when click outside it
        if (componentRef.current &&
            !componentRef.current.contains(event.target) &&
            isOpen) {
            setIsOpen(false);
        }
    }, [isOpen, setIsOpen, componentRef]);
    useEffect(() => {
        document.addEventListener('mousedown', collapseHandler);
        return () => document.removeEventListener('mousedown', collapseHandler);
    }, [collapseHandler]);
    return (_jsxs("div", { className: "range-dropdown", ref: componentRef, children: [_jsxs("div", { className: "range-dropdown-trigger", "aria-controls": collpaseId, onClick: handleClick, "aria-haspopup": "true", children: [_jsx("span", { children: placeholder }), _jsx("img", { src: dropDownIcon, alt: "" })] }), _jsxs(Collapse, { id: collpaseId, isOpened: isOpen, children: [_jsx(FormField, { type: "number", value: minimum, onChange: updateMinimum, label: 'Min ' + placeholder, placeholder: 'Min ' + placeholder, className: "range-dropdown-input" }), _jsx(FormField, { type: "number", value: maximum, onChange: updateMaximum, label: 'Max ' + placeholder, placeholder: 'Max ' + placeholder, className: "range-dropdown-input" })] })] }));
}
